import React from 'react';
import { Col, Row } from '../../../lib/utils';
import { Body2Bold, Body3Bold, Body3Regular } from '../../../lib/font';
import { colors } from '../../../lib/colors';
import { PaymentOrderView } from '../types';
import { formatAmount } from '../lib/format';

interface AmountSectionProps {
    amounts: PaymentOrderView['amounts'];
    /** 할인 행 라벨 — 강사 "선물 할인 (5%)" / 회원 "회원 할인 (5%)" */
    discountLabel: string;
    /** 회원용: 상품 금액에 정가 취소선 + 할인가 병기 */
    strikeListPrice?: boolean;
    /** 수량 지정 발송 — 2 이상이면 상품 금액 라벨에 단가 × 수량을 병기한다 */
    quantity?: number;
    /** 단가(정가) — quantity 병기 표기에만 사용, 합계는 항상 서버 amounts */
    unitPrice?: number;
}

const AmountSection: React.FC<AmountSectionProps> = ({
    amounts,
    discountLabel,
    strikeListPrice = false,
    quantity = 1,
    unitPrice,
}) => {
    const productLabel =
        quantity > 1 && unitPrice ? `상품 금액 (${formatAmount(unitPrice)}원 × ${quantity})` : '상품 금액';
    return (
        <Col
            style={{
                width: '100%',
                backgroundColor: '#FFFFFF',
                borderRadius: 16,
                padding: '20px',
                boxShadow: '0 2px 12px rgba(0, 0, 0, 0.06)',
            }}
        >
            <Body3Bold style={{ color: colors.LAVEL_4 }}>결제 금액</Body3Bold>
            <Row style={{ marginTop: 14, alignItems: 'center', justifyContent: 'space-between' }}>
                <Body3Regular style={{ color: colors.LAVEL_2 }}>{productLabel}</Body3Regular>
                {strikeListPrice ? (
                    <Row style={{ alignItems: 'center', gap: 6 }}>
                        <Body3Regular style={{ color: colors.LAVEL_1, textDecoration: 'line-through' }}>
                            {formatAmount(amounts.original)}원
                        </Body3Regular>
                        <Body3Regular style={{ color: colors.LAVEL_3, fontWeight: 600 }}>
                            {formatAmount(amounts.final)}원
                        </Body3Regular>
                    </Row>
                ) : (
                    <Body3Regular style={{ color: colors.LAVEL_3 }}>
                        {formatAmount(amounts.original)}원
                    </Body3Regular>
                )}
            </Row>
            <Row style={{ marginTop: 10, alignItems: 'center', justifyContent: 'space-between' }}>
                <Body3Regular style={{ color: colors.LAVEL_2 }}>{discountLabel}</Body3Regular>
                <Body3Regular style={{ color: colors.ERROR, fontWeight: 600 }}>
                    -{formatAmount(amounts.discountAmount)}원
                </Body3Regular>
            </Row>
            <div style={{ width: '100%', height: 1, backgroundColor: '#F0F0F0', margin: '14px 0' }} />
            <Row style={{ alignItems: 'center', justifyContent: 'space-between' }}>
                <Body3Bold style={{ color: colors.LAVEL_4 }}>최종 결제 금액</Body3Bold>
                <Body2Bold style={{ color: colors.primary }}>{formatAmount(amounts.final)}원</Body2Bold>
            </Row>
        </Col>
    );
};

export default AmountSection;
